import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useMemo } from 'react';
import { Link } from '@remix-run/react';
import { ArticleCtx } from '..';
const ArticleEntityWord = (props) => {
    const { buildHref, onEntityWordClick } = useContext(ArticleCtx);
    const { type, name, id } = props;
    const href = useMemo(() => buildHref(`/discover/${name}`), [buildHref, name]);
    const handleClick = useCallback((e) => {
        onEntityWordClick(e, {
            type,
            name,
            id,
        });
    }, [type, name, id]);
    return (_jsxs(Link, { to: href, className: "l8-entity-word", onClick: handleClick, children: [_jsx("span", { children: name }), _jsx("i", {})] }));
};
export const ArticleEntityWordComponentBuilder = (tag, attr) => {
    if (tag === 'a' && attr['class']?.includes('l8-entity-word')) {
        return {
            constructor: ArticleEntityWord,
            props: {
                type: attr['data-type'],
                name: attr['data-name'],
                id: attr['data-id'],
            },
        };
    }
    return null;
};
